import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const PolicySection = () => {
   const sectionRef = useRef(null);

   useEffect(() => {
      const ctx = gsap.context(() => {
         gsap.from(".policy-block", {
            y: 60,
            opacity: 0,
            duration: 1,
            stagger: 0.2,
            ease: "power3.out",
            scrollTrigger: {
               trigger: sectionRef.current,
               start: "top 80%",
            },
         });
      }, sectionRef);

      return () => ctx.revert();
   }, []);

   return (
      <section
         ref={sectionRef}
         className="bg-[#f9fafb] py-20"
      >
         <div className="max-w-5xl mx-auto px-4">

            {/* ================= PAGE HEADER ================= */}
            <div className="text-center mb-16 policy-block">
               <h1 className="text-4xl md:text-5xl font-semibold text-gray-800">
                  Privacy & Cancellation Policy
               </h1>
               <p className="mt-4 text-gray-600 text-lg max-w-3xl mx-auto">
                  We believe in complete transparency, trust, and responsibility.
                  Please read our policies carefully to understand how we serve you better.
               </p>
            </div>

            {/* ================= CANCELLATION POLICY ================= */}
            <div className="policy-block bg-white rounded-2xl shadow-sm p-8 md:p-10 mb-12">
               <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                  Cancellation Policy
               </h2>

               <div className="space-y-5 text-gray-700 leading-relaxed text-base md:text-lg">
                  <p>
                     • Cancellations made <strong>45 days or more</strong> before the
                     scheduled departure date will incur a <strong>25% cancellation fee</strong>.
                  </p>

                  <p>
                     • Cancellations made up to <strong>30 days</strong> prior to the
                     departure date will incur <strong>50% cancellation charges</strong>.
                  </p>

                  <p>
                     • Cancellations made within <strong>6 days</strong> of the departure
                     date will incur <strong>100% cancellation charges</strong>.
                  </p>

                  <p>
                     • Any non-refundable services such as permits, special bookings,
                     or third-party charges will be deducted as per actuals.
                  </p>
               </div>
            </div>

            {/* ================= PRIVACY POLICY ================= */}
            <div className="policy-block bg-white rounded-2xl shadow-sm p-8 md:p-10">
               <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                  Privacy Policy
               </h2>

               <div className="space-y-5 text-gray-700 leading-relaxed text-base md:text-lg">
                  <p>
                     • We respect your privacy and are committed to protecting the
                     personal information you share with us.
                  </p>

                  <p>
                     • All personal data collected during booking or enquiry is used
                     strictly for communication, service delivery, and internal records.
                  </p>

                  <p>
                     • We do not sell, rent, or share your personal information with
                     third parties without your consent, except when required by law.
                  </p>

                  <p>
                     • Payments made through our platform are processed via secure and
                     trusted payment gateways to ensure complete data protection.
                  </p>

                  <p>
                     • By using our services, you consent to the collection and use of
                     your information as described in this policy.
                  </p>
               </div>
            </div>

         </div>
      </section>
   );
};

export default PolicySection;
